import { request } from '../utils/http'

export const getAnniversaryList = () => request('/api/anniversary/list')

export const createAnniversary = (payload) => request('/api/anniversary', {
  method: 'POST',
  body: payload
})

export const updateAnniversary = (id, payload) => request(`/api/anniversary/${id}`, {
  method: 'PUT',
  body: payload
})

export const deleteAnniversary = (id) => request(`/api/anniversary/${id}`, {
  method: 'DELETE'
})

export const createAnniversaryMessage = (payload) => request('/api/anniversary/message', {
  method: 'POST',
  body: payload
})

export const getAnniversaryEggs = () => request('/api/anniversary/eggs')
